import { CONFIG, SELECTOR } from "./config.es6";

export default class View {
    constructor(root) {
        this.root = root;
    }

    setScreen(name) {
        const isResult = name === "result";
        const scrollY = window.scrollY;

        this.root.querySelectorAll(SELECTOR.screen).forEach((screen) => {
            const screenName = screen.dataset.shinkeisuijakuScreen;
            // 結果パネルは終了時の盤面へ重ねるため、result中もgameを背面に残す。
            const isForeground = screenName === name;
            const isVisible = isForeground || (name === "result" && screenName === "game");
            screen.hidden = !isVisible;
            screen.classList.toggle("is-active", isVisible);
            screen.setAttribute("aria-hidden", String(!isForeground));
            if (isForeground) {
                screen.removeAttribute("inert");
            } else {
                screen.setAttribute("inert", "");
            }
        });

        if (isResult) {
            // 終了時の盤面を同じ位置で見せ続け、前面の結果レイヤーだけをスクロールさせる。
            document.documentElement.style.setProperty("--scrolltop", `${scrollY}px`);
            document.body.classList.add("-inmodal");
            const result = this.root.querySelector(SELECTOR.result);
            if (result) result.scrollTop = 0;
            return;
        }

        document.body.classList.remove("-inmodal");
        document.documentElement.style.removeProperty("--scrolltop");
        window.scrollTo(0, 0);
    }

    setGameState(state) {
        this.root.dataset.gameState = state;
        ["title", "ready", "playing", "result", "success", "failure"].forEach((name) => {
            this.root.classList.toggle(`is-${name}`, name === state
                || (state === "success" && name === "result")
                || (state === "failure" && name === "result"));
        });
    }

    updateMatchedCount(matchedPairs) {
        const matched = this.root.querySelector(SELECTOR.matchedCount);
        const total = this.root.querySelector(SELECTOR.totalCount);
        if (matched) matched.textContent = String(matchedPairs);
        if (total) total.textContent = String(CONFIG.totalPairs);
    }

    updateTimer(remainingTime) {
        const timer = this.root.querySelector(SELECTOR.timer);
        if (!timer) return;
        const seconds = Math.max(0, Math.ceil(remainingTime));
        timer.textContent = this.formatTime(seconds);
        timer.classList.toggle("is-warning", seconds <= 20);
        timer.setAttribute("datetime", `PT${seconds}S`);
    }

    formatTime(seconds) {
        const minutes = Math.floor(seconds / 60);
        const rest = Math.floor(seconds % 60);
        return `${minutes}:${String(rest).padStart(2, "0")}`;
    }

    updateResult(isSuccess, elapsedSeconds, matchedPairs) {
        const result = this.root.querySelector(SELECTOR.result);
        if (result) result.dataset.result = isSuccess ? "success" : "failure";

        const heading = this.root.querySelector(SELECTOR.resultHeading);
        if (heading) heading.textContent = isSuccess ? "お見事！" : "残念！";

        const pairs = this.root.querySelector(SELECTOR.resultPairs);
        if (pairs) pairs.textContent = String(matchedPairs);

        const time = this.root.querySelector(SELECTOR.resultTime);
        if (time) time.textContent = String(elapsedSeconds);
    }
}
